import React from "react";
import { Dropdown, Option, Field } from "@fluentui/react-components";
import { useSelector } from "react-redux";

/**
 * Dropdown to select a queue from the tenant's QUEUES state.
 * On select, emits { queueId, queueName }.
 */
export default function QueueSelector({ label, value, onChange, disabled, placeholder }) {
  const QUEUES = useSelector((state) => state.reducer.QUEUES);
  const queues = Array.isArray(QUEUES) ? QUEUES : Object.values(QUEUES || {});

  const selected = queues.find((q) => q.id === value);
  const selectedText = selected?.displayName || selected?.name || (value ? value : "");

  return (
    <Field label={label} className="field-style">
      <Dropdown
        value={selectedText}
        selectedOptions={value ? [value] : []}
        onOptionSelect={(_, data) => {
          const q = queues.find((qq) => qq.id === data.optionValue);
          if (q) onChange({ queueId: q.id, queueName: q.displayName || q.name || q.id });
        }}
        disabled={disabled}
        placeholder={placeholder || "Select a queue..."}
      >
        {queues.map((q) => (
          <Option key={q.id} value={q.id} text={q.displayName || q.name || q.id}>
            {q.displayName || q.name || q.id}
          </Option>
        ))}
      </Dropdown>
    </Field>
  );
}
